// src/Pages/Usuario/Agenda/components/ModalConfirmacion.jsx
import React from "react";

export default function ModalConfirmacion({ resumenReserva, onClose }) {
  if (!resumenReserva) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 text-center relative animate-fadeIn">

        <h2 className="text-2xl font-bold text-emerald-600 mb-3">
          ¡Reserva recibida y en revisión!
        </h2>

        <p className="text-gray-700 mb-4 text-sm leading-relaxed">
          Hemos recibido tu comprobante de transferencia. <br />
          Tu reserva quedará aprobada una vez validemos el comprobante (dentro de un máximo de 24 horas). <br />
          Te enviaremos un correo con la confirmación.
        </p>

        {/* RESUMEN */}
        <div className="bg-emerald-50 border border-emerald-100 rounded-xl text-left text-sm p-4 mb-5 space-y-1">
          <p><strong>Nombre:</strong> {resumenReserva.nombre}</p>
          <p><strong>Correo:</strong> {resumenReserva.correo}</p>
          <p><strong>Servicio:</strong> {resumenReserva.servicio}</p>
          <p>
            <strong>Fecha:</strong> {resumenReserva.fecha} ·{" "}
            {resumenReserva.hora}
          </p>
          <p><strong>Monto pagado:</strong> {resumenReserva.monto}</p>
        </div>

        <button
          onClick={onClose}
          className="px-6 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold transition"
        >
          Aceptar
        </button>
      </div>
    </div>
  );
}
